import { useRef, useState } from "react";
import Dialog from "components/Overlays/ResponsiveDialog";
import { FiArrowUpRight, FiMapPin } from "react-icons/fi";
import { formatRecordedMoney } from "utils/recordedMoney";
import { PaymentType } from "utils/server-constants/paymentTypes";

const OrderDetails = ({
	order_number,
    currency, total_amount, currency_details,
	paymentType,
	subscription,
	books,
	reference,
	status,
	paymentMethod,
	created_at,
	shippingAddress,
	renderAction,
}) => {
	const [open, setOpen] = useState(false);
	const trigger = useRef(null);
	const close = () => {
		setOpen(false);
		trigger.current?.focus();
	};
	const details = [
		["Order number", order_number],
        ["Payment amount", formatRecordedMoney(total_amount, currency, currency_details)],
		["Reference", reference || "Not available"],
		["Type", paymentType],
		["Payment method", paymentMethod],
		["Status", status],
		["Placed on", created_at],
	];
	return (
		<>
			<button
				ref={trigger}
				type="button"
				className="account-order-link"
				aria-label={`View order ${order_number}`}
				aria-haspopup="dialog"
				onClick={() => setOpen(true)}
			>
				{order_number}
				<FiArrowUpRight aria-hidden="true" />
			</button>
			<Dialog
				visible={open}
				onHide={close}
				header="Order details"
				position="right"
				blockScroll
				draggable={false}
				resizable={false}
				dismissableMask
				className="account-dialog account-order-dialog"
				maskClassName="account-dialog-mask"
				ariaCloseIconLabel="Close order details"
			>
				<dl className="account-order-details">
					{details.map(([label, value]) => (
						<div key={label}>
							<dt>{label}</dt>
							<dd>{value || "Not available"}</dd>
						</div>
					))}
				</dl>
				{shippingAddress && (
					<section className="account-order-section">
						<h2>
							<FiMapPin aria-hidden="true" />
							Delivery address
						</h2>
						<div className="account-note">
							<div>
								<p>
									{[shippingAddress.street_address, shippingAddress.suburb]
										.filter(Boolean)
										.join(", ")}
								</p>
								<p>{[shippingAddress.city, shippingAddress.country].filter(Boolean).join(", ")}</p>
								<p className="mt-2">{shippingAddress.recipient_name}</p>
								<p>{shippingAddress.recipient_phone}</p>
							</div>
						</div>
					</section>
				)}
				{subscription && paymentType === PaymentType.Subscription && (
					<section className="account-order-section">
						<h2>Subscription purchased</h2>
						<p>{subscription.name}</p>
						<p className="account-helper">
							{subscription.duration} {subscription.time_unit} · Access to{" "}
							{subscription.max_number_of_books} books
						</p>
					</section>
				)}
				{books?.length > 0 && paymentType === PaymentType.Purchase && (
					<section className="account-order-section">
						<h2>Books purchased</h2>
						<ul className="account-purchased-books">
							{books.map((book) => (
								<li key={book.id}>
									<p>{book.title}</p>
									<p className="account-helper">By {book.author}</p>
									<div>
										<span>
											{book.quantity} {book.quantity === 1 ? "copy" : "copies"} ×{" "}
											{formatRecordedMoney(book.unit_amount ?? book.total_cost, book.currency, book.currency_details)}
										</span>
										<strong>
											{formatRecordedMoney(book.line_total ?? ((book.unit_amount ?? book.total_cost) * book.quantity), book.currency, book.currency_details)}
										</strong>
									</div>
								</li>
							))}
						</ul>
					</section>
				)}
				{renderAction && <div className="account-form-actions">{renderAction(close)}</div>}
			</Dialog>
		</>
	);
};
export default OrderDetails;
